import { Injectable, EventEmitter } from '@angular/core'

@Injectable()
export class HubEventsService {
  private events = {}

  subscribe(eventName, callback: Function) {
    const eventEmitter = this.createEventEmitter(eventName)

    return eventEmitter.subscribe(callback)
  }

  next(eventName) {
    const eventEmitter = this.createEventEmitter(eventName)

    eventEmitter.next(true)
  }

  private createEventEmitter(eventName): EventEmitter<any> {
    this.events[eventName] = this.events[eventName] || new EventEmitter()

    return this.events[eventName]
  }
}
